module.exports = __webpack_public_path__ + "img/tpc-4.6f29eae5.jpg";